<template>
  <div :class="['call-card', { 'call-card--matched': highlighted }]">
    <div class="card-title">
      <router-link
        style="text-decoration: none"
        :to="{
          name: 'GrantDetails',
          params: { grantId: id },
          query: { t: searchText },
        }"
        v-bind:target="openDetailsInNewTab ? '_blank' : null"
      >
        <h3 v-html="title" class="title bold-font"></h3>
      </router-link>
      <SelectButton
        class="select-btn"
        :id="schemeId"
        :allSelected="selectedResults"
      />
    </div>
    <span v-if="showIdentifier" class="identifier">{{ grant.identifier }}</span>
    <div class="card-details">
      <dl class="text-details">
        <dt class="detail-tag">Status</dt>
        <dd class="detail-value bold-font">{{ grant.status }}</dd>
        <dt class="detail-tag">{{ grant.currentDeadlineHeaderText }}</dt>
        <dd class="detail-value bold-font">{{ grant.currentDeadlineText }}</dd>
      </dl>
      <div class="action-icons">
        <q-icon
          class="action-icon"
          name="save"
          size="18px"
          @click="enableSaveScheme(schemeId)"
        >
          <q-tooltip> {{ t("search_schemes.save") }} </q-tooltip></q-icon
        >
        <q-icon
          class="action-icon"
          name="visibility_off"
          size="18px"
          @click="hideScheme(schemeId)"
        >
          <q-tooltip> Verbergen </q-tooltip></q-icon
        >
        <q-icon
          class="action-icon"
          name="share"
          size="18px"
          @click="shareGrant()"
        >
          <q-tooltip> {{ t("search_schemes.share") }} </q-tooltip></q-icon
        >
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import store from "../store/index";
import GrantsService from "../services/grants.service";
import SelectButton from "../components/GrantSelectButton.vue";
import SchemeUtils from "../utils/schemes";
import UserService from "../services/userprofile.service";
import { useI18n } from "vue-i18n";

export default {
  name: "CallCard",
  props: {
    id: String,
    title: String,
    introduction: String,
    grant: Object,
    highlighted: Boolean,
  },
  components: {
    SelectButton,
  },

  setup(props) {
    const schemeId = ref(props.id);
    const { locale } = useI18n();

    const selectedResults = computed(
      () => store.state.grantItems.selectedResults,
    );
    const openDetailsInNewTab = computed(
      () => store.state.user.openDetailsInNewTab,
    );
    const showIdentifier = computed(
      () => props.grant.identifier && props.grant.identifier.length > 0,
    );

    const enableSaveScheme = (id) => {
      store.commit("grantItems/addSelected", id);
      UserService.getFolders();
      store.commit("user/enableSaveScheme");
    };

    const shareGrant = () => {
      store.commit("grantItems/enableShareGrant", props.grant);
    };

    const hideScheme = async (schemeId) => {
      await GrantsService.hideScheme(schemeId, locale);
      SchemeUtils.searchSchemes(locale);
    };
    
    const searchText = computed({
      get: () => store.state.advancedSearch.searchText,
    });

    return {
      showIdentifier,
      openDetailsInNewTab,
      selectedResults,
      schemeId,
      shareGrant,
      enableSaveScheme,
      hideScheme,
      searchText
    };
  },
};
</script>
